import { inStage, unwrap, uploadAsset, type SagotClient } from "@sagot/api-client";
import { LOGO_ACCEPTED_TYPES, LOGO_MAX_BYTES, contentTypeFor } from "@sagot/constants";

type Api = SagotClient["api"];

/** Client checks before asking for an upload URL (the API re-validates type + size). */
export function logoProblem(file: File): "type" | "size" | null {
  const type = contentTypeFor(file);
  if (!LOGO_ACCEPTED_TYPES.some((accepted) => accepted === type)) return "type";
  if (file.size > LOGO_MAX_BYTES) return "size";
  return null;
}

/**
 * Presigned logo upload: `POST …/organization/logo` (presign) → PUT the bytes → `PATCH
 * …/organization` with the public URL (finalize). Failures are `UploadError`s tagged with their stage.
 */
export async function uploadLogo(api: Api, file: File): Promise<string> {
  const request = () => unwrap(api.POST("/v1/settings/organization/logo", { body: { content_type: contentTypeFor(file), filename: file.name, size_bytes: file.size } }));
  const url = await uploadAsset(request, file);
  await inStage("finalize", () => unwrap(api.PATCH("/v1/settings/organization", { body: { logo_url: url } })));
  return url;
}
